import { Maskable } from "models/domain/interfaces/maskable";
import formatWithMask from "utils/masks/format-with-masks";
import masks from "utils/masks/masks";
import { removeMasks } from "utils/remove-masks";

export class PhoneNumber implements Maskable {
    private static readonly phoneNumberRegex = /^(\+55)? ?\(?(\d{2})?\)? ?9? ?\d{4}[-| ]?\d{4}$/;
    private value: string;

    private constructor(value: string) {
        this.value = value;
    }

    public static fromString(value: string) {
        value = removeMasks(value.trim());
        const phoneNumber = new PhoneNumber(value);
        if (phoneNumber.getWithoutMask().length !== 11) {
            throw new Error('Telefone inválido');
        }

        if (!this.phoneNumberRegex.test(value)) {
            throw new Error('Telefone em formato inválido.')
        }

        return phoneNumber;
    }

    public getWithMask() {
        const { masked } = formatWithMask({
            mask: masks.BRL_PHONE,
            text: this.value
        });
        return masked;
    }

    public getWithoutMask() {
        return removeMasks(this.value);
    }
}